import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';
import type { ShipmentExceptionRow } from './shipment-exception-types';

export type { ShipmentExceptionRow } from './shipment-exception-types';

export default (
  accountId: Ref<number> | number,
  shipmentId: Ref<number> | number,
) => {
  return useQuery({
    queryKey: [
      'account-shipment-exceptions',
      () => unref(accountId),
      () => unref(shipmentId),
    ],
    queryFn: async (): Promise<ShipmentExceptionRow[]> => {
      const { api, baseURL } = getApi();
      const res = await api.get(
        `/api/v2/accounts/${unref(accountId)}/shipments/${unref(shipmentId)}/exceptions`,
        { baseURL },
      );
      return (res.data?.data ?? []) as ShipmentExceptionRow[];
    },
    enabled: !!unref(accountId) && !!unref(shipmentId),
  });
};
